import { render, staticRenderFns } from "./carousel-photos-block-edit.vue?vue&type=template&id=bda9cc4e&"
import script from "./carousel-photos-block-edit.vue?vue&type=script&lang=js&"
export * from "./carousel-photos-block-edit.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VTextarea } from 'vuetify/lib/components/VTextarea';
installComponents(component, {VTextarea})
